import { httpRequest, wrap } from './tools';

const DEFAULT_ACCOUNTS = [
  'MB_Multi_Inversion',
  'MB_Multi_Rentable',
  'MB_Electronica',
  'MB_Mibankito',
  'MB_Simplificada',
];

const postOpenAccountMB = async (payload, env) => {
  const fn = async () => {
    let url;
    switch (payload['type-account']) {
      case DEFAULT_ACCOUNTS[0]:
        url = !env
          ? `https://webhook.houndsoftware.net/9b749da192`
          : `https://webhook.houndsoftware.net/4a44d95cfd`; // Beta
        break;

      case DEFAULT_ACCOUNTS[1]:
        url = !env
          ? `https://webhook.houndsoftware.net/e7a42a0f8e`
          : `https://webhook.houndsoftware.net/316055b3f5`; // Beta
        break;

      case DEFAULT_ACCOUNTS[2]:
        url = !env
          ? `https://webhook.houndsoftware.net/654b144f6d`
          : `https://webhook.houndsoftware.net/b1236df9dc`; // Beta
        break;

      case DEFAULT_ACCOUNTS[3]:
        url = !env
          ? `https://webhook.houndsoftware.net/221af88172`
          : `https://webhook.houndsoftware.net/fef40ed153`; // Beta
        break;

      case DEFAULT_ACCOUNTS[4]:
        url = !env
          ? `https://webhook.houndsoftware.net/6a6ff5cff3`
          : `https://webhook.houndsoftware.net/a425d5e300`; // Beta
        break;

      default:
        url = !env
          ? `https://webhook.houndsoftware.net/9b749da192`
          : `https://webhook.houndsoftware.net/4a44d95cfd`; // Beta
        break;
    }
    const response = await httpRequest(url, 'POST', payload, false);

    return response.data;
  };

  return wrap(fn);
};

export { postOpenAccountMB };
